import { Component, OnDestroy, OnInit } from '@angular/core';
import * as fromWeeeFeedbackStore from '~shared/modules/weee-landing-page/store';
import { select, Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WEEE_STATUS } from '~shared/modules/weee-landing-page/constants/weee-response-status';
import { FRESHDESK_DE_LINK } from '~shared/constants/links.constants';

@Component({
  selector: 'app-weee-feedback',
  templateUrl: './weee-feedback.component.html',
  styleUrls: ['./weee-feedback.component.scss']
})

export class WeeeFeedbackComponent implements OnInit, OnDestroy {
  public FRESHDESK_URL_DE = FRESHDESK_DE_LINK;
  private unsubscribe$ = new Subject<void>();
  public status: string;
  public isLoading$: Observable<boolean>;
  public WEEE_STATUS = WEEE_STATUS;

  constructor(private store: Store<fromWeeeFeedbackStore.WeeeFeedbackState>) {
  }

  ngOnInit(): void {
    this.store.pipe(
      takeUntil(this.unsubscribe$),
      select(fromWeeeFeedbackStore.getWeeeFeedbackStatus))
      .subscribe(status => {
        this.status = status;
      });
    this.isLoading$ = this.store.pipe(select(fromWeeeFeedbackStore.getIsLoading));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
